module.exports = __webpack_public_path__ + "static/media/active-box.5b8d31a6.png";